<ng-container *ngIf="!isHistoryVisible && (cert.currentProgressList?.length ?? 0) > 0 && showCurrentProgress; else history">
	@if ((cert.currentProgressList?.length ?? 0) > 1) {
		<mat-form-field class="path-selector">
			<mat-label>
				<cm-localize [name]="locs.SPCertLogicViewLabelPath" [cpName]="locs.CPCertLogicViewLabelPath" />
			</mat-label>
			<mat-select [(ngModel)]="selectedTrack">
				@if ((isSp ? locs.SPCertLogicViewContentActive : locs.CPCertLogicViewContentActive) | localize | async; as activeLoc) {
					@for (progress of cert.currentProgressList; track $index) {
						<mat-option [value]="$index">{{progress?.logic?.displayStatus || activeLoc}}</mat-option>
					}
				}
			</mat-select>
		  </mat-form-field>
		
		<ng-container *ngIf="cert.currentProgressList[selectedTrack]?.itemTree; else noData">
			<cm-cert-logic-tree [data]="cert.currentProgressList[selectedTrack].itemTree">
			</cm-cert-logic-tree>
		</ng-container>
	} @else {
		<ng-container *ngIf="cert.currentProgressList[0]?.itemTree; else noData">
			<cm-cert-logic-tree [data]="cert.currentProgressList[0].itemTree">
			</cm-cert-logic-tree>
		</ng-container>
	}
</ng-container>

<ng-template #history>
	<ng-container *ngIf="cert.certHistoryList?.length; else noData">

		<div class="history" atsResponsive>
			<div class="history__list" role="tablist">
				<ng-container *ngFor="let pastCert of cert.certHistoryList">
					<button class="history__item" [ngClass]="{'history__item--selected': isItemSelected(pastCert.id)}"
						(click)="emitHistoryId(pastCert.id)" role="tab"
						[attr.aria-selected]="isItemSelected(pastCert.id)"
						[attr.aria-controls]="isItemSelected(pastCert.id) ? 'selected-history-tab' : 'hidden-tab'"
						[id]="pastCert.id" (keydown)="tabKeyHandler($event)" #tab>
						<span class="history__item--date">
							{{ pastCert.activeDate | cmDate }}
						</span>
						<span>
							{{ pastCert.type | cmLocalizeEnum: 'ChType' }}
						</span>
						@if (pastCert.logic?.displayStatus) {
							<span>
								{{ pastCert.logic.displayStatus }}
							</span>
						}
					</button>
				</ng-container>
			</div>

			<ng-container *ngIf="certHistoryDetail">
				<div class="history__details" id="selected-history-tab" tabindex="0" role="tabpanel"
					[attr.aria-labelledby]="certHistoryDetail.id">
					<ng-container *ngIf="certHistoryDetail.logicVersion?.itemTree; else noTree">
						<cm-cert-logic-tree [data]="certHistoryDetail.logicVersion.itemTree">
						</cm-cert-logic-tree>
					</ng-container>

					<ng-template #noTree>
						<cm-key-val-list class="history__details--left-spacing history__details--list">
							<div cm-key-val>
								<span kv-key>
									<span cmLocalize="Credential/System.LogicView.FieldLabel.Extension">
										Extension
									</span>
								</span>
								{{ certHistoryDetail.activeDate | cmDate }}
							</div>
							<div cm-key-val
								*ngIf="certHistoryDetail.expireDate && certHistoryDetail.expireDate !== certHistoryDetail.inactiveDate">
								<span kv-key>
									<span cmLocalize="Credential/System.LogicView.FieldLabel.NewInactive">
										New Inactive
									</span>
								</span>
								{{ certHistoryDetail.inactiveDate | cmDate }}
							</div>
							<div cm-key-val *ngIf="certHistoryDetail.expireDate">
								<span kv-key>
									<span cmLocalize="Credential/System.LogicView.FieldLabel.NewExpires">
										New Expires
									</span>
								</span>
								{{ certHistoryDetail.expireDate | cmDate }}
							</div>
							<div cm-key-val>
								<span kv-key>
									<span cmLocalize="Credential/System.LogicView.FieldLabel.Type">
										Type
									</span>
								</span>
								{{ certHistoryDetail.type | cmLocalizeEnum: 'ChType' }}
							</div>
							<div cm-key-val *ngIf="certHistoryDetail.linkedCert?.certCatalog?.name">
								<span kv-key>
									<span cmLocalize="Credential/System.LogicView.FieldLabel.LinkedCred">
										Linked Credential
									</span>
								</span>
								{{ certHistoryDetail.linkedCert.certCatalog.name }}
							</div>
						</cm-key-val-list>
					</ng-template>
				</div>
			</ng-container>
		</div>

	</ng-container>
</ng-template>


<ng-template #noData>
	<p [cmLocalize]="locFeature + '/System.Global.Content.NoData'">No data
		available</p>
</ng-template>
